import type { SurveyAnswer } from '../components/questions'
import type { SurveyQuestion } from '@bandos/shared'

export function isAnswered(value: SurveyAnswer | undefined): boolean {
  if (value === null || value === undefined) return false
  if (typeof value === 'string') return value.trim().length > 0
  if (Array.isArray(value)) return value.length > 0
  return true
}

export function defaultValue(type: SurveyQuestion['type']): SurveyAnswer {
  if (type === 'open') return ''
  if (type === 'checkbox') return []
  return null
}
